import apiInstance from "../api";
import fileApiInstance from "../fileApi";
import endPoints from "../endpoints";
import { delay } from "../helpers";
import getPlans from "../../mocks/getPlans.json";
import payrollAndCensusData from "../../mocks/payrollAndCensusData.json";
import eligibilityOverrideData from "../../mocks/eligibilityOverrideData.json";
import fundingDetails from "../../mocks/fundingDetails.json";
import forfeitureDetails from "../../mocks/forfeitureMaster.json";
import fundingTransactionDetails from "../../mocks/fundingTransactionDetails.json";

//import createAPIInstance from "../api";

export const getRecordUnlock = (id) => {
  return apiInstance().get(`${endPoints.payroll.recordUnlock}/${1}`);
  // return delay(1000).then(() => {
  //   return {IsSuccessfull:false};
  // });
};

export const getEligibilityInformation = (payload) => {
  // return delay(1000).then(() => {
  //   return eligibilityOverrideData;
  // });
  return apiInstance().get(
    `${endPoints.census.getEligibilityInformation}/${payload.planId}/${payload.employeeId}`
  );
};

export const getEligibilityHistory = (payload) => {
  // return delay(1000).then(() => {
  //   return eligibilityOverrideData[0].history;
  // });
  return apiInstance().get(
    `${endPoints.census.getEligibilityHistory}/${payload.planId}/${payload.sourceId}/${payload.employeeId}`
  );
};

export const getErrorAndWarningMetadata = (id) => {
  return apiInstance().get(
    `${endPoints.payroll.errorAndWarningMetadata}/${id}`
  );
};

export const downloadpreviewfile = (fileUploadId) => {
  return fileApiInstance().get(
    `${endPoints.payroll.downloadpreviewfile}/${fileUploadId}`
  );
};

export const getCountsForErrorReportTabs = (payload) => {
  return apiInstance().get(
    `${endPoints.payroll.getCountsForErrorReportTabs}/${payload}`
  );
};

export const getSummaryReport = (payload) => {
  return apiInstance().post(
    `${endPoints.census.getEligibilitySummaryReport}`,
    payload
  );
};
export const ParticipantAnalytics = (payload) => {
  return apiInstance().get(
    `${endPoints.ParticipantAnalytics.participantAnalytics}?selectedPeriod=${payload.SelectedPeriod}&startDate=${payload.startDate}&endDate=${payload.endDate}&informationOn=${payload.informationOn}&employeeId=${payload.employeeId}&groupBy=${payload.groupBy}`
  );
};
export const getDetailReport = (payload) => {
  return apiInstance().post(
    `${endPoints.census.getEligibilityDetailReport}`,
    payload
  );
};
export const getWarningsInECR = (payload) => {
  return apiInstance().post(`${endPoints.payroll.GetWarningsList}`, payload);
};
export const getErrorsInECR = (payload) => {
  return apiInstance().post(`${endPoints.payroll.GetErrorList}`, payload);
};
export const getAllRecords = (payload) => {
  return apiInstance().post(`${endPoints.payroll.getAllRecordsList}`, payload);
};
export const getPayrollDetails = () => {
  return apiInstance().get(endPoints.plan.getPlanCount);
};

export const postCreatePayroll = (payload) => {
  return apiInstance().post(endPoints.payroll.createPayroll, payload);
};

export const createPayrollFromUI = (payload) => {
  return apiInstance().post(endPoints.payroll.createPayrollFromUI, payload);
};

//Manage Payroll
export const getPayrollTileCard = () => {
  return delay(1000).then(() => {
    //  return payrollAndCensusData;
  });
};
export const saveFundingDetails = (payload) => {
  return apiInstance().post(`${endPoints.payroll.saveFundingDetails}`, payload);
};

export const confirmFunds = (payload) => {
  return apiInstance().post(`${endPoints.payroll.confirmFunds}`, payload);
};

export const saveFundingDetailsByPlan = (payload) => {
  return apiInstance().post(
    `${endPoints.payroll.saveFundingDetailsByPlan}`,
    payload
  );
};

export const saveFundingByClassificationDetails = (payload) => {
  return apiInstance().post(
    `${endPoints.payroll.saveFundingByClassificationDetails}`,
    payload
  );
};

export const saveFundingDetailsByFile = (payload) => {
  return apiInstance().post(
    `${endPoints.payroll.saveFundingDetailsByFile}`,
    payload
  );
};

export const getClassificationDetailsByFileId = (payload) => {
  return apiInstance().post(
    `${endPoints.payroll.getClassificationDetailsByFileId}`,
    payload
  );
};

export const saveEligibilityInformation = (payload) => {
  return apiInstance().post(
    `${endPoints.payroll.saveEligibilityInformation}`,
    payload
  );
};

export const getFilesBasedOnSearch = (payload) => {
  return apiInstance().post(
    `${endPoints.payroll.getFilesBasedOnSearch}`,
    payload
  );
};

export const getFilesCountBasedOnSearch = (payload) => {
  return apiInstance().post(`${endPoints.payroll.getFileUploadCount}`, payload);
};

export const getCorrectAcceptDuplicateEmployee = (payload) => {
  return apiInstance().post(
    `${endPoints.payroll.getCorrectAcceptDuplicateEmployee}`,
    payload
  );
};

export const getRevalidateFile = (payload) => {
  return apiInstance().post(`${endPoints.payroll.getRevalidateFile}`, payload);
};

export const getFileInformationByFileId = (fileId) => {
  return apiInstance().get(
    `${endPoints.payroll.getFileInformationById}/${fileId}`
  );
};

export const getDuplicateEmployeeByFileId = (fileId) => {
  return apiInstance().get(
    `${endPoints.payroll.getDuplicateEmployeeByFileId}/${fileId}`
  );
};

export const getDuplicateRecord = (payload) => {
  return apiInstance().post(`${endPoints.payroll.getDuplicateRecord}`, payload);
};

export const getFileGraphInformationById = (fileId) => {
  return apiInstance().get(
    `${endPoints.payroll.getFileGraphInformation}/${fileId}`
  );
};

export const getPayrollMetaDataDetails = (fileId) => {
  return apiInstance().get(
    `${endPoints.payroll.getPayrollMetaDataInfo}/${fileId}`
  );
};

export const getPayrollEmployeesSSNAndNameByFileId = (fileId) => {
  return apiInstance().get(
    `${endPoints.payroll.getPayrollEmployeesSSNAndNameByFileId}/${fileId}`
  );
};

export const getTempCreatePayroll = (fileId) => {
  return apiInstance().get(
    `${endPoints.payroll.GetTempCreatePayroll}/${fileId}`
  );
};

export const getPayrollEmployeeDetails = (fileId) => {
  return apiInstance().get(
    `${endPoints.payroll.getPayrollEmployeeDetails}/${fileId}`
  );
};

export const getCreatePayrollInformationByFileId = (
  fileId
  // companyId,
  // payrollFrequencyId
) => {
  return apiInstance().get(
    `${endPoints.payroll.getCreatePayrollInformationByFileId}/${fileId}`
  );
};
export const downloadCreatePayrolldetail = (
  employeeData,
  companyId,
  fileUploadId
) => {
  return apiInstance().post(
    `${endPoints.payroll.downloadCreatePayrolldetail}/${companyId}/${fileUploadId}`,
    employeeData
  );
};
export const UpdatePayrollEmployee = (employeeData) => {
  return apiInstance().post(
    endPoints.payroll.UpdatePayrollEmployee,
    JSON.stringify(employeeData)
  );
};

export const submitCreatePayroll = (employeeData, companyId, fileUploadId) => {
  return apiInstance().post(
    `${endPoints.payroll.submitCreatePayroll}/${companyId}/${fileUploadId}`,
    employeeData
  );
};

export const postCompanyDetails = (payload) => {
  return apiInstance().post(endPoints.payroll.ErrorList, payload);
};

export const getRecordLock = (id) => {
  return apiInstance().get(`${endPoints.payroll.recordLock}/${id}`);
  // return delay(1000).then(() => {
  //   return {
  //     IsSuccessfull:true
  //   };
  // });
};
export const finalSubmit = (id, fileType) => {
  return apiInstance().get(
    `${endPoints.payroll.finalSubmit}/${id}/${fileType}`
  );
};
export const finalSubmitAndFunding = (id, fileType) => {
  return apiInstance().get(
    `${endPoints.payroll.finalSubmitAndFunding}/${id}/${fileType}`
  );
};
export const getEmployerSources = (planId) => {
  return apiInstance().get(`${endPoints.payroll.getEmployerSources}/${planId}`);
};

export const getComputationalPeriods = (payload) => {
  return apiInstance().get(
    `${endPoints.payroll.getComputationalPeriods}/${payload.planId}/${payload.sourceId}/${payload.employeeId}`
  );
};
export const submitAndUpdateECR = (payload, fileType) => {
  return apiInstance().post(
    `${endPoints.payroll.submitAndUpdateTempEmployeeInECR}/${fileType}`,
    payload
  );
};

export const getCompanyPlanPayrollFrequencies = () => {
  return apiInstance().get(endPoints.payroll.getCompanyPlanPayrollFrequencies);
};

//ECR
//-------------------
export const getRecordDetailsInGetWarningScreen = (payload) => {
  return apiInstance().post(
    `${endPoints.payroll.getRecordDetailsInGetWarningScreen}`,
    payload
  );
};

export const acceptAllWarningsInaFile = (id) => {
  return apiInstance().post(
    `${endPoints.payroll.acceptAllWarningsInaFile}/${id}`
  );
};

export const acceptAllDataChangeValidationInaFile = (payload) => {
  return apiInstance().post(
    `${endPoints.payroll.acceptAllDataChangeValidationInaFile}`,
    payload
  );
};

export const acceptEmployeeWarnings = (payload) => {
  return apiInstance().post(
    `${endPoints.payroll.acceptEmployeeWarnings}`,
    payload
  );
};

export const acceptWarningByMessageCode = (id, messageCode, lookUpIds) => {
  var payload = {
    fileId: parseInt(id),
    messageCode: messageCode,
    lookUpIds: lookUpIds,
  };
  return apiInstance().post(
    `${endPoints.payroll.acceptWarningsByMessage}`,
    payload
  );
};
export const getSourceDeferral = (id) => {
  return apiInstance().get(`${endPoints.payroll.getSourceDeferral}/${id}`);
};

export const getAllEmployeeLoans = (planId, employeeId) => {
  return apiInstance().get(
    `${endPoints.payroll.getAllEmployeeLoans}/${planId}/${employeeId}`
  );
};

//Payroll Funding
//------------------
export const getFundingDetailsByFile = (FileId) => {
  return apiInstance().get(
    `${endPoints.payroll.getFundingDetailsByFile}/${FileId}`
  );
};

export const getFundingDetailsByClassification = (
  FileId,
  ClassificationTypeName
) => {
  //classificationId
  return apiInstance().get(
    `${endPoints.payroll.getFundingDetailsByClassification}/${FileId}/${ClassificationTypeName}`
  );
};
export const getAwaitingFundingDetailsByPlan = (fileId, planId) => {
  return apiInstance().get(
    `${endPoints.payroll.getAwaitingFundingDetailsByPlan}/${fileId}/${planId}`
  );
};

export const getAwaitingFundingDetailsByClassification = (
  fileId,
  planId,
  classificationCodeId
) => {
  return apiInstance().get(
    `${endPoints.payroll.getAwaitingFundingDetailsByClassification}/${fileId}/${planId}/${classificationCodeId}`
  );
};

export const getFundingDetailByPlan = (FileId) => {
  return apiInstance().get(
    `${endPoints.payroll.getFundingDetailByPlan}/${FileId}`
  );
};

export const getCustodianBankDetails = (payload) => {
  return apiInstance().get(
    `${endPoints.payroll.getCustodianBankDetails}/${payload.planId}/${payload.fileId}`
  );
};

export const getForfeitureDetails = (payload) => {
  const { planId, fileId } = payload;
  return apiInstance().get(
    `${endPoints.payroll.getForfeitureDetails}/${planId}/${fileId}`
  );
};

export const checkClassificationCanBeDeleted = (typeId) => {
  return apiInstance().get(
    `${endPoints.payroll.checkClassificationTypePresent}/${typeId}`
  );
};

export const getFundingDetailByDivision = (FileId) => {
  return apiInstance().get(
    `${endPoints.payroll.getFundingDetailByDivision}/${FileId}`
  );
};

export const getFundingTransactionDetailsByClassification = (payload) => {
  const { classificationCodeId, planId, fileId } = payload;
  return apiInstance().get(
    `${endPoints.payroll.getFundingTransactionDetailsByClassification}/${classificationCodeId}/${planId}/${fileId}`
  );
};

export const getFundingTransactionDetailsByPlan = ({ planId, fileId }) => {
  return apiInstance().get(
    `${endPoints.payroll.getFundingTransactionDetailsByPlan}/${planId}/${fileId}`
  );
};

export const getFundingTransactionDetailsOfEmployeeInPayrollSubmissionPage = ({
  fileId,
  employeeId,
}) => {
  return apiInstance().get(
    `${endPoints.payroll.getFundingTransactionDetailsOfEmployeeInPayrollSubmissionPage}/${fileId}/${employeeId}`
  );
};

export const retrievePayrollDetailsByFileId = (FileId) => {
  return apiInstance().get(
    `${endPoints.payroll.retrievePayrollDetailsByFileId}/${FileId}`
  );
};

export const retrieveBankDetails = (planId) => {
  return apiInstance().get(
    `${endPoints.payroll.retrieveBankDetails}/${planId}`
  );
};

//--------

export const getExistingEmployeeDetails = (companyId) => {
  return apiInstance().get(
    `${endPoints.payroll.getEmployeeDetailsbycompanyandplan}/${companyId}`
  );
};

export const addEmployeeToPayrollData = (payload) => {
  return apiInstance().get(
    `${endPoints.payroll.addEmployeeToPayroll}/${payload}`
  );
};

export const removeEmployeeFromPayrollData = (id) => {
  return apiInstance().delete(
    `${endPoints.payroll.removeEmployeeFromPayroll}/${id}`
  );
};
export const deleteTempEmployeeById = (id) => {
  return apiInstance().delete(
    `${endPoints.payroll.deleteTempEmployeeId}/${id}`
  );
};
export const getTempEmployeeDetailsforPayroll = (id) => {
  return apiInstance().get(`${endPoints.payroll.getTempEmployeeDetails}/${id}`);
};

export const saveEmployeeInformationInPayroll = (payload) => {
  return apiInstance().get(
    `${endPoints.payroll.updateEmployeeToPayroll}/${payload}`
  );
};
export const employeeCensusInformation = (id) => {
  return apiInstance().get(
    `${endPoints.payroll.getEmpCensusInformation}/${id}`
  );
};
export const getDataTyeMisMatchErrors = (fileId) => {
  return apiInstance().get(
    `${endPoints.payroll.getDataTypeMisMatches}/${fileId}`
  );
};
export const editContributionDetails = (id) => {
  return apiInstance().get(
    `${endPoints.payroll.getTempEmployeeDetailsByssn}/${id}`
  );
};
export const payrollAndCensusFileUpload = (payload) => {
  return apiInstance().post(
    endPoints.payroll.payrollAndCensusFileUpload,
    payload,
    { headers: { "content-type": "multipart/form-data" } }
  );
};
export const AddBeneficary = (payload) => {
  return apiInstance().post(`${endPoints.payroll.AddBeneficary}`, payload);
};
export const tempMappingFileUpload = (payload) => {
  return apiInstance().post(endPoints.payroll.TempMappingFileUpload, payload);
};

export const deleteUploadedFileById = (id) => {
  return apiInstance().delete(`${endPoints.payroll.deleteFileById}/${id}`);
};
export const deleteCensusFileById = (id) => {
  return apiInstance().delete(
    `${endPoints.payroll.deleteCensusFileById}/${id}`
  );
};

export const getTempEmployeeDetailsById = (payload) => {
  return apiInstance().get(
    `${endPoints.payroll.getTempEmployeeDetailsById}/${payload}`
  );
};

// Payroll Report

export const getFileInformationWithErrorDetailsById = (fileid) => {
  return fileApiInstance().get(
    `${endPoints.reports.getFileInformationWithErrorDetailsById}/${fileid}`
  );
};

export const getSourceLevelPayrollDetailsById = (fileid) => {
  return fileApiInstance().get(
    `${endPoints.reports.getSourceLevelPayrollDetailsById}/${fileid}`
  );
};

export const getDataChangeInformation = (fileid, from, count) => {
  return fileApiInstance().get(
    `${endPoints.reports.getDataChangeInformation}/${fileid}/${from}/${count}`
  );
};

export const getDataOverrideInformation = (fileid, from, count) => {
  return fileApiInstance().get(
    `${endPoints.reports.getDataOverrideInformation}/${fileid}/${from}/${count}`
  );
};

export const getErrorValidationInformation = (fileid, from, count) => {
  return fileApiInstance().get(
    `${endPoints.reports.getErrorValidationInformation}/${fileid}/${from}/${count}`
  );
};

export const getPayrollFundingInformation = (fileid) => {
  return fileApiInstance().get(
    `${endPoints.reports.getPayrollFundingInformation}/${fileid}`
  );
};

export const getDownloadDataChangeReport = (fileid) => {
  return fileApiInstance().get(
    `${endPoints.reports.getDownloadDataChangeReport}/${fileid}`
  );
};

export const getDownloadDataOverrideReport = (fileid) => {
  return fileApiInstance().get(
    `${endPoints.reports.getDownloadDataOverrideReport}/${fileid}`
  );
};

export const getDownloadErrorValidationReport = (fileid) => {
  return fileApiInstance().get(
    `${endPoints.reports.getDownloadErrorValidationReport}/${fileid}`
  );
};

export const getDownloadFundingReport = (fileid) => {
  return fileApiInstance().get(
    `${endPoints.reports.getDownloadFundingReport}/${fileid}`
  );
};

export const getDownloadInputFileReport = (fileid) => {
  return fileApiInstance().get(
    `${endPoints.payroll.getDownloadUploadedFileReport}/${fileid}`
  );
};

export const getDownloadSubmittedFileReport = (fileid) => {
  return fileApiInstance().get(
    `${endPoints.payroll.getDownloadSubmittedFileReport}/${fileid}`
  );
};

export const getForfeitureSummaryDetails = () => {
  return apiInstance().get(endPoints.payroll.getForfeitureSummaryDetails);
};

export const getForfeitureSourceHistoryTransactions = (payload) => {
  return apiInstance().get(
    `${endPoints.payroll.getForfeitureSourceHistoryTransactions}/${payload.sourceId}/${payload.planId}`
  );
};

export const getDownloadPayrollReport = (payload) => {
  return fileApiInstance().post(
    endPoints.payroll.getDownloadPayrollReport,
    payload
  );
};

export const getEmployeeCount = () => {
  return apiInstance().get(endPoints.payroll.getEmployeeCount);
};

export const getPlanCount = () => {
  return apiInstance().get(endPoints.payroll.getPlanCount);
};

export const getCompanyCount = () => {
  return apiInstance().get(endPoints.payroll.getCompanyCount);
};

export const downloadCompensationReport = (payload) => {
  return fileApiInstance().post(
    `${endPoints.payroll.downloadCompensationReport}`,
    payload
  );
};

export const getEmployeeContributionAndCompensation = (payload) => {
  return apiInstance().post(
    `${endPoints.payroll.getEmployeeContributionAndCompensation}`,
    payload
  );
};
export const getEmployeeListByFilter = (payload) => {
  return apiInstance().post(
    `${endPoints.payroll.getEmployeeListByFilter}`,
    payload
  );
};

export const getPayrollFrequencyBasedOnFileUploadId = (payload) => {
  return apiInstance().post(
    `${endPoints.payroll.getPayrollFrequencyBasedOnFileUploadId}`,
    payload
  );
};

export const getEmployeeIdBasedOnFileUploadId = (payload) => {
  return apiInstance().post(
    `${endPoints.payroll.getEmployeeIdBasedOnFileUploadId}`,
    payload
  );
};

export const regenerateOutputFile = (payload) => {
  return apiInstance().post(
    `${endPoints.payroll.OutputFileRegenerate}`,
    payload
  );
};
